module.exports = __webpack_public_path__ + "img/2_x2.2274fd8e.png";